import { call, put, takeLatest } from 'redux-saga/effects';
import { Pagination } from '@models/Pagination';
import { SagaPayload } from '@utils/typescript';
import { GetAllInsurancePolicyParams, InsurancePolicyApi } from '@apis/InsurancePolicyApi';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { insurancePoliciesFetch, stateUpdate, StateUpdatePayload } from './action';

function* handleInsurancePoliciesFetch({ payload }: SagaPayload<GetAllInsurancePolicyParams>) {
  const state: StateUpdatePayload = { policies: null, pagination: undefined };
  try {
    const [policies, pagination] = (yield call(InsurancePolicyApi.getAll, payload)) as [InsurancePolicy[], Pagination];
    state.policies = policies;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePoliciesFetch, handleInsurancePoliciesFetch);
}
